module.exports = __webpack_public_path__ + "static/media/drone-photo-product.460117ec.jpg";